import React from 'react';
import classes from './Button_green.module.css';
import { useNavigate } from "react-router-dom";
const Button_green = ({children, onClick, phase, id, ...props}) => {
  const navigate = useNavigate();
  
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else if (phase !== undefined && id !== undefined) {
      navigate('/Products/');
    }
  };
  
  return (
      <button {...props} className={classes.myBtn} onClick={handleClick}>
          {children}
      </button>
  )
};

export default Button_green;
